import { useTranslations } from '@vocab/react';
import { Alert, Text, RadioGroup, RadioItem, Box } from 'braid-design-system';
import type { FocusEvent, ChangeEvent, FormEvent } from 'react';

import { INPUT_MAX_LENGTH_DEFAULT } from 'src/app/shared/constants/formDataFields';
import { TextFieldWithCounter } from 'src/app/v1/views/shared/TextFieldWithCounter';

import translations from './.vocab';

export interface PayShownToggleProps {
  isANZ: boolean;
  salaryText: string;
  handleSalaryTextOnBlur: (event: FocusEvent<HTMLInputElement>) => void;
  validationMessage: string | null;
  payDisplayToggleValue: 'show' | 'hide';
  handlePayShownToggleChange: (event: FormEvent<HTMLInputElement>) => void;
  handleSalaryTextChange: (event: ChangeEvent<HTMLInputElement>) => void;
  payDisplayToggleAlertText: string;
}

export const PayShownToggle = ({
  isANZ,
  salaryText,
  handleSalaryTextOnBlur,
  validationMessage,
  payDisplayToggleValue,
  handlePayShownToggleChange,
  handleSalaryTextChange,
  payDisplayToggleAlertText,
}: PayShownToggleProps) => {
  const { t } = useTranslations(translations);

  return (
    <RadioGroup
      id="payDisplayToggle"
      value={payDisplayToggleValue}
      onChange={handlePayShownToggleChange}
      label={t('pay-display-text-label')}
      secondaryLabel={t('pay-display-text-secondary-label')}
    >
      <RadioItem label={t('pay-display-toggle-show-label')} value="show">
        {isANZ && (
          <Box position="relative">
            <TextFieldWithCounter
              id="PayDetailsTextField"
              value={salaryText}
              onBlur={handleSalaryTextOnBlur}
              onChange={handleSalaryTextChange}
              isValid={!Boolean(validationMessage)}
              message={
                validationMessage || t('pay-display-text-default-message')
              }
              maxCharacters={INPUT_MAX_LENGTH_DEFAULT}
              data={{ 'hj-whitelist': 'true' }}
            />
            {/* TODO: (NVL) uncomment after theme switch */}
            {/* <Box right={0} top={0} position="absolute">
        <ContextualHelp onToggleOn={handleTooltipToggleOn}>
          <Text>{t('pay-display-text-help-text')}</Text>
        </ContextualHelp>
      </Box> */}
          </Box>
        )}
      </RadioItem>
      <RadioItem label={t('pay-display-toggle-hide-label')} value="hide">
        {payDisplayToggleValue === 'hide' && (
          <Alert id="payDisplayToggleAlert" tone="caution">
            <Text>{payDisplayToggleAlertText}</Text>
          </Alert>
        )}
      </RadioItem>
    </RadioGroup>
  );
};
